import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router-dom'
import * as routes from 'core/routing/constants/index'
import MainContentWrapper from 'core/templates/MainContentWrapper'
import wizardsShape from 'core/components/wizard/shapes'
import styled from 'styled-components'
import { injectIntl, FormattedMessage } from 'react-intl'
import { isMobile } from 'react-device-detect'
import Hydrator, { hydratorMethods } from 'core/hydrator'
import { Row, Col, Card, Empty, ButtonGhost } from 'core/components/ui' //, Button
import { greys, font } from 'assets/themes/theme-default'
import VehicleDetail from 'core/layouts/vehicle-detail'
import SVG from 'core/components/svg'
import svg from 'assets/svg'

import { configuratorShape } from '../shapes'
import { tradeInShape } from '../../trade-in/shapes'

const StyledCard = styled(Card)`
  .ant-card-head {
    margin-bottom: ${isMobile && '0'};
  }
  .ant-card-body {
    padding-top: ${isMobile && '5px'};
  }
`
const CardSectionLabel = styled.div`
  font-size: ${font.size.lg};
  font-weight: ${font.weight.bold};
  color: ${greys.dark1};
  margin: 0 0 10px 0;
`

const PencilIcon = styled(SVG)`
  width: 15px;
  fill: currentColor;
`
const LabelValuePriceWrapper = styled(Row)`
  margin: 10px 0;
`
const ColValuePrice = styled(Col)`
  text-align: right;
`
const PricesWrapper = styled.div`
  font-size: ${font.size.xs};
  line-height: ${font.size.sm};
  color: ${greys.dark3};
  margin: 0px 0 15px;
  text-align: center;
  border-bottom: 1px solid ${greys.dark3};
  padding: 0 0 10px 0;
`
const ColLabelPrice = styled(Col)`
  text-align: left;
`

const ColLabelTotalPrice = styled(ColLabelPrice)`
  color: ${greys.dark1};
  font-weight: ${font.weight.bold};
  font-size: ${font.size.base};
`
const ColValueTotalPrice = styled(ColValuePrice)`
  color: ${props => props.theme.colors.color1.bg};
  font-weight: ${font.weight.bold};
  font-size: ${font.size.base};
`

const Finalization = props => {
  const { setLayoutModalInfo, wizards, intl, history, configurator, tradeIn } = props //

  const newCar = Hydrator.hydrate(hydratorMethods.HYDRATE_VEHICULE_FROM_CONFIGUARTOR, configurator)
  const tradeInVehicle = tradeIn.vehicle
  const { tradeInprice } = tradeIn

  const vehicle = Hydrator.hydrate(hydratorMethods.HYDRATE_VEHICULE_FROM_CONFIGUARTOR, configurator)
  const { prices, price } = vehicle
  const { totalOptionsPrice, totalServiceContractsPrice, totalPaintPrice, totalSaddleries } = prices
  const totalPrice =
    price + totalOptionsPrice + totalServiceContractsPrice + totalPaintPrice + totalSaddleries

  const displayModalDeleteConfigurator = () => {
    const modalInfos = {
      showModal: true,
      title: intl.formatMessage({ id: 'configurator-modal-delete-configurator-title' }),
      content: intl.formatMessage({ id: 'configurator-modal-delete-configurator-content' }),
      route: routes.HOME
    }

    setLayoutModalInfo(modalInfos)
  }

  const displayModalDeleteTradeIn = () => {
    const modalInfos = {
      showModal: true,
      title: intl.formatMessage({ id: 'configurator-modal-delete-tradein-title' }),
      content: intl.formatMessage({ id: 'configurator-modal-delete-tradein-content' }),
      route: routes.CONFIGURATOR_TRADEIN
    }

    setLayoutModalInfo(modalInfos)
  }

  const goToTradeIn = () => {
    history.push(routes.CONFIGURATOR_TRADEIN)
  }
  /*
  const goToFinancing = () => {
    history.push(routes.CONFIGURATOR_FUNDING)
  }

*/

  const renderButtonEdit = action => (
    <ButtonGhost onClick={action} size="small" block style={{ padding: '0px' }}>
      <PencilIcon svg={svg.pencil} />
    </ButtonGhost>
  )

  const renderPrice = (label, value) => (
    <>
      {value > 0 && (
        <LabelValuePriceWrapper type="flex" gutter={20}>
          <ColLabelPrice span={16}>{label}</ColLabelPrice>
          <ColValuePrice span={8}>{value}</ColValuePrice>
        </LabelValuePriceWrapper>
      )}
    </>
  )

  const RenderTotalPrice = () => (
    <>
      {totalPrice > 0 && (
        <LabelValuePriceWrapper type="flex" gutter={20}>
          <ColLabelTotalPrice span={16}>
            <FormattedMessage id="Total" />
          </ColLabelTotalPrice>
          <ColValueTotalPrice span={8}>
            {price +
              totalOptionsPrice +
              totalServiceContractsPrice +
              totalPaintPrice +
              totalSaddleries}
          </ColValueTotalPrice>
        </LabelValuePriceWrapper>
      )}
    </>
  )

  useEffect(() => {
    const aStepsActive = wizards[wizards.activeWizard]

    const extendedStepsActive = aStepsActive.filter(
      step => step.hash === routes.CONFIGURATOR_FINALIZATION
    )
    const currentStep = extendedStepsActive[0]

    const { isActive } = currentStep

    if (!isActive) {
      history.push(routes.HOME)
    }
  }, [])

  return (
    <MainContentWrapper
      data-test="component-configurator-finalization"
      title={intl.formatMessage({ id: 'configurator-finalization-title' })}
    >
      <Row type="flex">
        <Col lg={16} xs={24} order={isMobile && 2}>
          <StyledCard
            title={intl.formatMessage({
              id: 'configurator-finalization-card-title-1'
            })}
            bordered={false}
          >
            {newCar ? (
              <VehicleDetail vehicle={newCar} showDetails price={newCar.price} />
            ) : (
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}
          </StyledCard>

          <StyledCard
            title={intl.formatMessage({
              id: 'configurator-finalization-card-title-2'
            })}
            bordered={false}
          >
            {tradeInVehicle.wsDatas && tradeInprice ? (
              <VehicleDetail vehicle={tradeInVehicle} showDetails price={tradeInprice.amount} />
            ) : (
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}
          </StyledCard>

          <StyledCard
            title={intl.formatMessage({
              id: 'configurator-finalization-card-title-3'
            })}
            bordered={false}
          >
            financing
          </StyledCard>
        </Col>
        <Col offset={1} lg={7} xs={24} order={isMobile && 1}>
          <StyledCard
            bordered={false}
            title={intl.formatMessage({ id: 'configurator-finalization-card-title-4' })}
          >
            <CardSectionLabel>
              <Row type="flex" gutter={20}>
                <Col span={19}>
                  <FormattedMessage id="Véhicule acheté" />
                </Col>
                <Col span={5}> {renderButtonEdit(displayModalDeleteConfigurator)}</Col>
              </Row>
            </CardSectionLabel>
            {prices && totalPrice > 0 && (
              <PricesWrapper>
                {renderPrice(intl.formatMessage({ id: 'prewiew-vehicle-price-1' }), price)}
                {renderPrice(
                  intl.formatMessage({ id: 'prewiew-vehicle-price-2' }),
                  totalOptionsPrice
                )}
                {renderPrice(
                  intl.formatMessage({ id: 'prewiew-vehicle-price-3' }),
                  totalServiceContractsPrice
                )}
                {renderPrice(
                  intl.formatMessage({ id: 'prewiew-vehicle-price-4' }),
                  totalPaintPrice
                )}
                {renderPrice(
                  intl.formatMessage({ id: 'prewiew-vehicle-price-5' }),
                  totalSaddleries
                )}
                {<RenderTotalPrice />}
              </PricesWrapper>
            )}
            <CardSectionLabel>
              <Row type="flex" gutter={20}>
                <Col span={19}>
                  <FormattedMessage id="Véhicule repris" />
                </Col>
                <Col span={5}>
                  {tradeInVehicle
                    ? renderButtonEdit(displayModalDeleteTradeIn)
                    : renderButtonEdit(
                        goToTradeIn,
                        intl.formatMessage({ id: 'configurator-finalization-card-button-2' })
                      )}
                </Col>
              </Row>
            </CardSectionLabel>
            <PricesWrapper>
              {tradeIn.wsDatas ? (
                <FormattedMessage id="Estimation" />
              ) : (
                <Empty imageStyle={{ height: '35px' }} image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )}
            </PricesWrapper>
            <CardSectionLabel>
              <FormattedMessage id="Financement" />
            </CardSectionLabel>
            <PricesWrapper>
              <FormattedMessage id="Financement" />
            </PricesWrapper>
          </StyledCard>
        </Col>
      </Row>
    </MainContentWrapper>
  )
}

Finalization.propTypes = {
  intl: PropTypes.shape().isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  wizards: wizardsShape.isRequired,
  configurator: configuratorShape.isRequired,
  tradeIn: tradeInShape.isRequired,
  setLayoutModalInfo: PropTypes.func.isRequired
}

export default withRouter(injectIntl(Finalization))
